import NotEnabledMessage from './index';
import ContentConnector from '@wix/restaurants-components-css-modules/dist/shared/I18nProvider/ContentConnector';

export default ContentConnector({prefix: 'disabled_'})(NotEnabledMessage);